/**
* Preflight check of user variables 
* Booking connection to server 
*/

import { logger, dId, dQS, dQSa, showError, showPopUp } from "./utils";
import { reservaD, json_response } from "./variables";
import { langDict } from "./dict";
import { redrawDivs } from "./result_render";
import { ajax_book_reserva, ajax_ping_status } from "./ajax";
import { show_loader, hide_loader, end_tick } from "./loader_ticker";
import { google_send_book } from "./google";

declare const IMAGE_BASE: string;
declare const GCLID: string;
declare const AJAX_BASE: string;
declare const URL_BASE: string;

let reservaSending = false;
let poll_timer: number;
let ping_count: number;
const max_ping: number = 15 * 12;		// Check bank for 15 minutes, then expire. 
const ping_interval: number = 10*1000;		// Check bank every 5 seconds.


function addFlightCheckListeners() {

  logger("Adding flight check listeners", "log");

  let flightBtns = dQSa(".flight-check-btn");
  let terminos = <HTMLInputElement>dId("showTC");

  flightBtns.forEach((btn) => {

    btn.removeEventListener("click", (e) => {});

    btn.addEventListener("click", (e) => {
      flightCheck(e);
    });

  });


  terminos.addEventListener("click", showTerms);

}


// Show terms and conditions for selected vehicle (on reservation connfirmation step):
function showTerms() {

  const terminos = <HTMLInputElement>dId("TC_description");
  const terminos_text = terminos.innerHTML;
  showPopUp(terminos_text);

}



// Added BIZUM Payment option 2021-04
function flightCheck(e: Event): boolean {

  const btn = <HTMLButtonElement>e.target;
  const flight_id = btn.id;

  const news = <HTMLInputElement>dId("f_news");

  let form_valid = false;

  logger("Payment Method: " + flight_id, "log");

  if (flight_id == "res_prepay") {

    reservaD[77] = "Pre-Pago";

  } else if (flight_id == "res_bizum") {

    reservaD[77] = "Bizum";

  } else if (flight_id == "res_oficina") {

    reservaD[77] = "Oficina";

  } else {

    reservaD[77] = "Pre-Pago";

  }

  if (news.checked) {
    reservaD[66] = 1;
  } else {
    reservaD[66] = 0;
  }

  cleanTelefono();

  // Set client vars: 

  reservaD[65] = (<HTMLInputElement>dId("f_vuelo")).value;
  reservaD[70] = (<HTMLInputElement>dId("f_prenombre")).value + " " + (<HTMLInputElement>dId("f_apellidos")).value;
  reservaD[71] = (<HTMLInputElement>dId("f_correo")).value;
  reservaD[72] = (<HTMLInputElement>dId("f_tel")).value;
  reservaD[73] = (<HTMLInputElement>dId("f_dni")).value;
  reservaD[74] = (<HTMLInputElement>dId("f_comment")).value;

  form_valid = checkForm();

  if (form_valid) {

    (<HTMLElement>dId("resPayment")).innerHTML = '<img src="' + URL_BASE + 'img/spinner.svg" class="icon-accent spin">' + langDict[43];

    redrawDivs(5);  // show Bank Connecting (hide rest)

    placeOrder();

  }

  return form_valid;

}


/** send order to server */
function placeOrder() {

  if (reservaSending) {
    logger("Reserva already sending", "warn");
    return;
  }

  // Price change warning ticker:
  end_tick();
  toggle_book_buttons(true);

  let data: string[] = [];

  reservaD.forEach((e, i) => {
    if (e != "") {
      data[i] = e;
    } else {
      data[i] = "0";
    }
  });

  // Try to thwart double clickers:
  reservaSending = true;

  ajax_book_reserva(data, GCLID)
  .then((json) => {

    reservaSending = false;

    let res: json_response = json as json_response;

    if (res.status == null || res.status == "" || res.status.toUpperCase() == "ERROR") {

      logger("Error realizando reserva!", "error");
      showError(langDict[19]);
      hide_loader();
      redrawDivs(3);

      toggle_book_buttons(false);

     
    } else {

      let r = res.result;

      if (r != null && r.length == 3) {

        logger("Reserva accepted", "log");
        hide_loader();
        google_send_book(r[1]);

        // Show order number on screen before connecting to bank:
        const link = AJAX_BASE + "_presupuestoGW.php?m=" + r[0] + "&o=" + r[1] + "&k=" + r[2];

        document.location.href = link;
        return; 
        /*
        const link_msg = `${langDict[51]} <a href="${link}" target="_blank">${langDict[52]}</a>`;
        const link_popup = `${langDict[58]} <a href="${link}" target="_blank">${langDict[52]}</a>`;

        const msg = `<p><img src="${URL_BASE}img/check.svg" class="icon-alert" alt="">
                    ${langDict[50]} <strong>${r[1]}</strong></p>
                    <p id="connect_bank_link">${link_msg}</p>`;

        (<HTMLElement>dId("resSaved")).innerHTML = msg;

        (<HTMLElement>dId("resPayment")).innerHTML = '<img src="' + URL_BASE + 'img/spinner.svg" class="icon-alert spin">' + langDict[43];

        redrawDivs(4);

        const popup_bank = window.open(link, "popup_bank", 'width=1000, height=700, left=24, top=24, scrollbars, resizable');
        
        if (popup_bank == null || typeof(popup_bank)=='undefined') {  
          document.location.href = link;
        } else {  
          popup_bank.focus();
        }


        // Open status window on screen: 
        ping_count = 0;
        poll_timer = setInterval( () => { pingOrder( r ); }, ping_interval);

        */
      }

    } // if status.

  });

}


/** Check reservation status for 15 minutes after order is placed.
 * Show message depending on status and stop timer once order is confirmed/failed or expired.
 */
function pingOrder(r: any) {

  logger("Ping order status", "log");
  ping_count += 1;


  // After ping count > 3, hide message to connect to bank.
  if (ping_count > 2) {
    (<HTMLElement>dId("connect_bank_link")).style.display = "none";
  }


  let data = { o:   r[1], k: r[2] };
  let msg = "";

  ajax_ping_status(data)
  .then((json) => {

    let res: json_response = json as json_response;

    if (res.status == null || res.status == "" || res.status.toUpperCase() == "ERROR") {

      // Keep trying in case connection is bad, but order is good: 
      logger("Error solicitando estado pago (" + ping_count + ")", "error");
      msg = langDict[57];

    } else {

      let r :any = res.result;

      let code = r.payment_status.toUpperCase() ?? "P";
      let payment_ref = r.payment_reference;

      logger("Estado pago: " + code + " (" + payment_ref + ")", "log");

      if (r == null) {
        msg = langDict[57];
      }

  
      // Pending
      if (code == "P") {

        msg = '<img src="' + URL_BASE + 'img/spinner.svg" class="icon-alert spin">' +  langDict[55];

        // Authorised:
      } else if (code == "A") {

        msg = langDict[53];
        end_order_tick();

      // Rejected - allow to try again: 
      } else if (code == "R") {
        msg = langDict[54];
        end_order_tick();

        toggle_book_buttons(false);

        // Expired:
      } else if (code == "X") {
        msg = langDict[56];
        end_order_tick();
      }

    }

    (<HTMLElement>dId("resPayment")).innerHTML = msg;
    redrawDivs(5); 

  });

  // Noone home - for too long. 
  if (ping_count > max_ping) {

    msg = langDict[56];
    end_order_tick();

    (<HTMLElement>dId("resPayment")).innerHTML = msg;
    redrawDivs(5); 

  }

  

}


function end_order_tick() {

  logger("End polling order status", "log");

  try {
    clearInterval(poll_timer);
  } catch (err) {
    logger("No timeout to clear", "error");
  }

}


// @param bool. true = disabled
function toggle_book_buttons(onoff: boolean) {
  
  let res_btns = dQSa(".flight-check-btn");

  res_btns.forEach((btn) => {
    (<HTMLInputElement>btn).disabled = onoff;
  });

}




// BOOKING FORM CHECK VALID ENTRIES:
function checkForm() {

  logger("Validating form", "log");

  const reqEle = ["f_prenombre", "f_apellidos", "f_correo", "f_tel", "f_dni", "f_terms", "f_edad"];
  const reqEmail = "f_correo";
  const reqFlight = "";

  let OK = true;

  (<HTMLElement>dId("errText")).innerHTML = "";

  for (let i = 0; i < reqEle.length; i++) {

    let elem = <any>dId(reqEle[i]);

    // strip spaces: 
    elem.value = elem.value.trim();

    // Reset error color:
    elem.classList.remove("form-error");

    if (elem.type == "text" || elem.type == "textarea") {
      if (elem.value == "") {
        elem.classList.add("form-error");
        logger("Error: " + elem.name + " is missing", "warn");
        OK = false;
      }
    } else if (elem.type == "select" || elem.type == "select-one") {

      if (elem.selectedIndex < 0) {
        elem.classList.add("form-error");
        OK = false;
      }
    } else if (elem.type == "checkbox") {

      if (elem.checked != true) {
        elem.parentElement.classList.add("form-error");
        OK = false;
      } else {
        elem.parentElement.classList.remove("form-error");
      }
    }
  }

  if (OK != false) { OK = checkEmail(reqEmail); }

  if (reqFlight !== "" && OK != false) { OK = checkFlight(reqFlight); }

  if (!OK) {
    (<HTMLElement>dId("errText")).innerHTML = langDict[73];
  }

  return (OK);

}


function checkEmail(v: string) {

  logger("Checking email: " + v, "log");

  const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  let OK = true;

  let elem = <HTMLInputElement>dId(v);

  if (elem == null) {
    return false;
  }

  // Filter valid email: 
  if (!re.test(elem.value)) {
    showError(langDict[74]);
    elem.focus();
    elem.classList.add("form-error");

    OK = false;
  }

  return (OK);
}


function checkFlight(v: string) {

  logger("Checking flight: " + v, "log");

  var re = /^[a-z]\w\d{4}$/i;
  let OK = true;

  let elem = <HTMLInputElement>dId(v);

  if (elem == null) {
    return false;
  }

  if (!re.test(elem.value)) {

    showError("Formato de vuelo XX1234");
    elem.focus();
    elem.classList.add("form-error");

    OK = false;
  }

  

  return (OK);
}


// Leave only digits and prefix in telephone
function cleanTelefono() {

  const regex = /[^0-9+]/g;
  const tel = <HTMLInputElement>dId("f_tel");
  const tel_no = tel.value.replace(regex, "");
  tel.value = tel_no;

}



export { addFlightCheckListeners }